export default "__VITE_ASSET__Gm555r6r__"